<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="System Setting"
      text="Update System Setting"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              v-if="localSystemSetting.key=='KATIMAS_WORKSPACE_INTEGRATION'"
              cols="12"
            >
              <v-autocomplete
                v-model="localSystemSetting.value"
                v-validate="'required'"
                :error-messages="errors.collect('value')"
                :items="booleanList"
                data-vv-name="value"     
                data-vv-as="value"            
                item-text="value"
                item-value="key"
                label="Value"
              />
            </v-col>
            <v-col
              v-else-if="localSystemSetting.key=='BASED_COUNTRY'"
              cols="12"
            >
              <v-autocomplete
                v-model="localSystemSetting.value"
                v-validate="'required'"
                :error-messages="errors.collect('value')"
                :items="countries"
                data-vv-name="name"     
                data-vv-as="name"            
                item-text="name"
                item-value="id"
                label="Value"
              />
            </v-col>
            <v-col
              v-else-if="localSystemSetting.key=='LEAVE_ROLLOVER'"
              cols="12"
            >
              <v-autocomplete
                v-model="localSystemSetting.value"
                v-validate="'required'"
                :error-messages="errors.collect('value')"
                :items="leaveRolloverList"
                data-vv-name="value"     
                data-vv-as="value"            
                item-text="value"
                item-value="key"
                label="Value"
              />
            </v-col>
            <v-col
              v-else-if="localSystemSetting.key=='MAX_USER_PASSWORD_ATTEMPTS' || localSystemSetting.key=='COMPANY_FORMERLY_KNOWN_CARRY_DURATION' ||localSystemSetting.key=='LOCATION_ACCEPTABLE_RADIUS'"
              cols="12"
            >
              <v-text-field
                v-model="localSystemSetting.value"
                v-validate="'required|integer'"
                :error-messages="errors.collect('value')"
                data-vv-name="value"                
                label="Value"
                type="number"
                min="0"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>
            <v-col
              v-else-if="localSystemSetting.key=='EMPLOYEE_NUMBER_LENGTH'"
              cols="12"
            >
              <v-text-field
                v-model="localSystemSetting.value"
                v-validate="'required|integer|employeeNumberLengthValidate|largerEmployeeNumberLengthValidate'"
                :error-messages="errors.collect('value')"
                data-vv-name="value"                
                label="Value"
                type="number"
                min="1"
                max="10"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>
            <v-col
              v-else
              cols="12"
            >
              <v-text-field
                v-model="localSystemSetting.value"
                v-validate="'required'"
                :error-messages="errors.collect('value')"
                data-vv-name="value"                
                label="Value"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"      
          class="white--text px-10"     
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      systemsetting: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localSystemSetting: null,
        booleanList: [
          { key: '1', value: 'Yes' },
          { key: '0', value: 'No' },
        ],
        leaveRolloverList: [
          { key: 'CALENDAR', value: 'By Calendar year' }, // normal usage (lock leave, then rollover manually)
          // { key: 'FINANCIAL', value: 'By Financial year' }, // no details yet
          // { key: 'ANNIVERSARY', value: 'By Anniversary year' }, // will auto rollover all leave entitlement upon employee's anniversary
        ],
        countries: [],
        loading: false,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localSystemSetting = { ...this.systemsetting }

        let _this = this
        this.$validator.extend('employeeNumberLengthValidate', {
          getMessage (field, args) {
            return 'only allow from 1 to 10'
          },
          validate (value, args) {
            return _this.isValidEmployeeNumberLength(value)
          },
        })
        this.$validator.extend('largerEmployeeNumberLengthValidate', {
          getMessage (field, args) {
            return 'setting value cannot lesser than current value'
          },
          validate (value, args) {
            return _this.isLargerEmployeeNumberLength(value)
          },
        })
        this.loadCountries()
      },
    },
    methods: { 
      isValidEmployeeNumberLength (value) {
        if (value > 0 && value <= 10) { 
          return true 
        }
        return false
      },
      isLargerEmployeeNumberLength (value) {
        if (parseInt(this.systemsetting.value) <= parseInt(value)) { 
          return true 
        }
        return false
      },
      loadCountries () {
        this.$api.countries().list()
          .then(response => {
            this.countries = response.data

            this.loading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)
            
            this.$api.systemSettings().update(this.systemsetting.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.setProgressing(false)
              })
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        let data = { value: this.localSystemSetting.value }
        return data
      },
    },
  }
</script>
